import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { OnboardingDashBoardService } from '../services/onboardingDashBoardService';
import { OAuthService } from 'angular-oauth2-oidc';
import { CookieService } from 'ngx-cookie-service';
import { SeamlessHeaderComponent } from '../shared/seamless-header.component';
import { CommonModule } from '@angular/common';
import { FailedCreditScoreComponent } from '../failed-credit-score/failed-credit-score.component';
import { TitleCasePipe } from '../helpers/pipe/title-case.pipe';
import { DashboardService } from '../services/dashboard.service';
import { Enum } from '../helpers/enums/enum';

@Component({
  selector: "app-welcome",
  templateUrl: "./welcome.component.html",
  styleUrls: ["./welcome.component.css"],
  standalone: true,
  imports: [CommonModule, SeamlessHeaderComponent,FailedCreditScoreComponent, TitleCasePipe]
})
export class WelcomeComponent implements OnInit {
  successMsg = "You have been successfully verified.";
  fadeOutSuccessMsg = false;
  moved = false;
  displayScoreContent = false;
  isDataAvailable = true;
  scoreNumber = 0;
  scoreColor = "#30955F";
  scoreStatus = "Okay";
  variantPercent = 0;
  variantText = "Let's turn this around";
  userName = "";  
  userData = null;
  setPosition=false;
  radius = 90;
  centerX = 100;
  centerY = 100;
  circumference = Math.PI * this.radius;
  strokeOffset = this.circumference;
  animateCSdial=false;

  currentValue = 0;                           // Starting at 0 for animation
  targetValue = 1000;                        // Max value

  private animationDuration = 500;
  private frameRate = 1000 / 60;
  private totalFrames = this.animationDuration / this.frameRate;
  private frame = 0;
  iconX: number | null = 10000;
  iconY: number | null = 10000;
  iconRotation: number | null = null;
  private internalArrowRotationDeg = 17.2376; 
  readonly arrowPivotX = 18.5203;
  readonly arrowPivotY = 17.5199;
  constructor(private onboardingDashBoardService: OnboardingDashBoardService,private dashboardService: DashboardService,   
    private oauthService: OAuthService, private cookieService: CookieService, private el: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit(): void {

  }
  ngOnInit() {
    localStorage.setItem('PageUrls', 'onboarding');
    this.dashboardService.SendSignalData({"SignalType":1}).subscribe({});
    let userDataStr = localStorage.getItem('apiUserModel');
    this.userData = userDataStr ? JSON.parse(userDataStr) : null;
    this.userName = this.userData?.given_name;
    this.getCreditHistory();
    setTimeout(() => {
      
      this.fadeOutSuccessMsg = true;
      this.successMsg = "";
      this.moved = true;
    }, 2000);
    
    setTimeout(() => {
      this.displayScoreContent = true;
      this.setPosition = true;
      this.renderer.addClass(this.el.nativeElement, 'bg-active');
    }, 2500);
  }

  getCreditHistory(): void {
    this.onboardingDashBoardService.getOnboardingCreditHistory()
    .subscribe({
        next: (response: any) => {
        const scoreInfo = response?.scoreInformation;
        if (!response || response.isDataAvailable === false || !scoreInfo) {
          this.isDataAvailable = false;
          return;
        }
      
        this.isDataAvailable =response?.isDataAvailable??false;

        this.scoreNumber = scoreInfo.score ?? 0;
        if (this.scoreNumber === null || this.scoreNumber === undefined) {
          this.scoreNumber = 0;
        }
        this.currentValue = 0;
        this.strokeOffset = this.circumference;
        this.frame = 0;
        this.animateCSdial = false;
        setTimeout(() => {
          this.animateCSdial = true;
          this.animateProgressTo(this.scoreNumber);
        }, 0);
        this.animateProgressTo(this.scoreNumber);
        this.variantPercent = response.creditInsightSummaryDetails?.variationPrecentage ?? 0;
        this.variantText = response.creditInsightSummaryDetails?.variationHeading ?? "Let's turn this around";
        this.userName = response.userName ?? "";
        this.scoreColor = response.uiTextElement?.colorCode ?? "#FF0000";

        this.setScoreStatus();
      },
      error:(error) => {
        this.isDataAvailable = false;
      }
  });
  }



  setScoreStatus() {
    if (this.scoreNumber >= 0 && this.scoreNumber <= 2) {
       this.scoreStatus = 'Not enough info';
    }
    if (this.scoreNumber >= 3 && this.scoreNumber <= 600) {
      this.scoreStatus = 'Needs work';
    }
    if (this.scoreNumber >= 601 && this.scoreNumber <= 800) {
     this.scoreStatus = 'Below average';
    }
    if (this.scoreNumber >= 801 && this.scoreNumber <= 850) {
      this.scoreStatus = 'Average';
    }
    if (this.scoreNumber >= 851 && this.scoreNumber <= 900) {
      this.scoreStatus = 'Good';
    }
    if (this.scoreNumber >= 901 && this.scoreNumber <= 1000) {
      this.scoreStatus = 'Excellent';
    }
  }

    animateProgressTo(value: number): void {
    const target = Math.min(value, this.targetValue);
    const step = () => {
      const progress = this.frame / this.totalFrames;
      this.currentValue = Math.round(progress * target);

      const percent = this.currentValue / this.targetValue;
      this.strokeOffset = this.circumference * (1 - percent);

      const angle = Math.PI * percent;
      const phi = Math.PI - angle; 

      this.iconX = this.centerX + this.radius * Math.cos(phi);
      this.iconY = this.centerY - this.radius * Math.sin(phi);

      const dx = (this.iconX as number) - this.centerX;
      const dy = (this.iconY as number) - this.centerY;
      const radialAngle = Math.atan2(dy, dx); // φ in radians

      const tangentDeg = (radialAngle * 180) / Math.PI + 90;
      this.iconRotation = tangentDeg - 2.1 * this.internalArrowRotationDeg;

      this.frame++;

      if (this.frame <= this.totalFrames) {
        requestAnimationFrame(step);
      } else {
        this.currentValue = target;
        this.strokeOffset = this.circumference * (1 - target / this.targetValue);
      }
    };

    this.frame = 0;
    requestAnimationFrame(step);
  }
}
